// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"1def11ba","510":"81305b3e"}[chunkId] + ".chunk.js";
};